<template>
  <div class="autocomplete-text-input-fi">
    <div class="autocomplete-text-input-fi__container">
      <text-input-fi
        :model-value="inputValue"
        class="autocomplete-text-input-fi__input"
        :label="label || undefined"
        :light="light"
        :required="required"
        @update:model-value="inputChanged"
        @keyup-enter="setFirstOption"
      />

      <div
        v-if="
          !hideSuggestions &&
          suggestions &&
          (hideSingleSuggestion ? suggestions.length > 1 : suggestions.length > 0)
        "
        class="autocomplete-text-input-fi__suggestions"
      >
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-for="(option, idx) in suggestions"
          :key="`${option}-${idx}`"
          class="autocomplete-text-input-fi__suggestion"
          @click="inputChanged(option)"
          v-html="highlightText(option)"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import escapeHtml from 'escape-html';
import { ref, watch } from 'vue';

import TextInputFi from '../text-input-fi/TextInputFi.vue';

const props = withDefaults(
  defineProps<{
    value?: string | null;
    suggestions?: string[] | null;
    label?: string | null | undefined;
    light?: boolean;
    required?: boolean;
    highlight?: boolean;
    hideSingleSuggestion?: boolean;
  }>(),
  {
    value: null,
    suggestions: null,
    label: null,
    light: false,
    required: false,
    highlight: false,
  },
);

const emit = defineEmits<{
  (e: 'change', value: string): void;
}>();
const inputValue = ref(props.value);
const hideSuggestions = ref(false);

watch(
  () => props.value,
  (newValue) => {
    inputValue.value = newValue;
  },
);

const highlightText = (text: string): string => {
  if (props.highlight && inputValue.value) {
    const escapedInput = inputValue.value.replace(/[.*+?^${}()|[\]\\-]/g, '\\$&');
    return text.replace(
      new RegExp(escapedInput, 'i'),
      (match) => `<span class="fi-semibold">${escapeHtml(match)}</span>`,
    );
  }
  return text;
};
const inputChanged = (val: string): void => {
  hideSuggestions.value = val === (props.suggestions?.[0] || '');
  inputValue.value = val;
  emit('change', inputValue.value || '');
};

const setFirstOption = (): void => {
  if (props.suggestions && props.suggestions.length > 0) {
    inputChanged(props.suggestions[0]);
  }
};
</script>

<style scoped src="./autocomplete-text-input-fi" />
